export const CONNECT = 'CONNECT';
export const DISCONNECT = 'DISCONNECT';
export const IS_CONNECTED = 'IS_CONNECTED';
export const CONNECT_TO_MOLLIE = 'CONNECT_TO_MOLLIE';
